import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createSettingsSubMenu } from "src/routing/navigation";

const SettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default SettingsSubMenu;
